export const DEAL_TYPE_LABELS = {
  sale: "Продаж",
  rent: "Оренда",
};

export const PROPERTY_TYPE_LABELS = {
  apartment: "Квартира",
  house: "Будинок",
  land: "Земельна ділянка",
  commercial: "Комерційна",
  industrial: "Промислова",
};

export const PRICE_MODE_LABELS = {
  property_price: "Ціна об'єкта",
  custom_price: "Власна ціна",
  on_request: "Ціна за запитом",
};

export const LOCATION_PRECISION_LABELS = {
  exact: "Точна адреса",
  street: "Вулиця без номера",
  area: "Лише район/населений пункт",
};

export const STATUS_LABELS = {
  active: "Активна",
  revoked: "Відкликана",
  expired: "Протермінована",
  unavailable: "Недоступна",
};

const CURRENCY_GLYPH = {
  USD: "$",
  EUR: "€",
  UAH: "₴",
};

export function formatPriceAmount(amount, currency) {
  if (amount === null || amount === undefined || amount === "") return null;
  const numeric = typeof amount === "number" ? amount : Number(amount);
  if (!Number.isFinite(numeric)) return null;
  const formatted = numeric.toLocaleString("uk-UA", {
    maximumFractionDigits: 2,
  });
  const glyph = CURRENCY_GLYPH[currency] || "";
  return `${glyph}${formatted}`.trim();
}

export function formatResolvedPrice(price) {
  if (!price || price.mode === "on_request") return "Ціна за запитом";
  const formatted = formatPriceAmount(price.amount, price.currency);
  return formatted || "Ціна за запитом";
}

export function formatDateTime(iso) {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleString("uk-UA", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatDate(iso) {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  const yyyy = date.getFullYear();
  const mo = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${dd}.${mo}.${yyyy}`;
}

export function presentationStatus(share) {
  if (!share) return "unavailable";
  if (share.is_active_now) return "active";
  if (share.expires_at && new Date(share.expires_at).getTime() <= Date.now()) {
    return "expired";
  }
  if (share.revoked_at) return "revoked";
  return "unavailable";
}

export function presentationRequiresExpiryRestore(share, from = new Date()) {
  if (!share) return false;
  return Boolean(
    share.expires_at && new Date(share.expires_at).getTime() <= from.getTime(),
  );
}

export function formatLocationLine(location) {
  if (!location || typeof location !== "object") return "";
  if (location.formatted_address) return location.formatted_address;
  const parts = [
    location.named_object,
    location.building_number,
    location.local_area,
    location.settlement_name,
    location.region_name,
  ];
  return parts.filter(Boolean).join(", ");
}
